import React from "react";
import { getClassName } from "@sscs/utils";
import styles from "./chainLayout.module.scss";
const Layout = ({ children }) => {
    return React.createElement("div", { className: styles.layout }, children);
};
const Label = ({ children }) => {
    return React.createElement("div", { className: styles.label }, children);
};
const Chain = ({ signatureType, children }) => {
    return (React.createElement("div", { className: getClassName(styles.chain, styles[`${signatureType}-chain`]) }, children));
};
const Line = ({ isActive, className }) => {
    return (React.createElement("div", { className: getClassName(styles["connection-line"], className, {
            [styles["active-line"]]: isActive,
        }) }));
};
const Signature = ({ signatureType, children, }) => {
    return (React.createElement("div", { className: getClassName(styles.signature, styles[`${signatureType}-metadata`]) }, children));
};
export default {
    Chain,
    Label,
    Layout,
    Line,
    Signature,
};
//# sourceMappingURL=ChainLayout.js.map